import * as React from 'react';
import {Modal, Table} from 'antd';
import locales from '../locales';
import {GroupedInventoryStockItemForCostInfo, MaintenanceHistoryItemEntry} from '../api/dtos/dtos';
import {ColumnProps} from "antd/lib/table";
import {simpleColumn} from "../utils/table-utils";
import {numberGroupFormatter, renderFixedPriceColumn} from "../utils/number-utils";

interface Props {
  costInfoEntry: MaintenanceHistoryItemEntry;
  onEntryCostInfoCancel: () => void;
}

class MaintenanceEntryGroupModal extends React.Component<Props, {}> {
  public render(): React.ReactNode {

    return (
      <Modal
        title={locales.unit_price}
        visible={true}
        footer={null}
        onCancel={this.props.onEntryCostInfoCancel}
        destroyOnClose={true}
      >
        <Table
          dataSource={this.getSortedGroupedRows(this.props.costInfoEntry)}
          columns={this.groupInfoColumns()}
          rowKey={this.getRowKey}
          bordered={true}
          size="small"
          pagination={false}
        />
      </Modal>
    );
  }

  private getRowKey = (record: any, index: number): string => {
    return index.toString();
  };

  private groupInfoColumns = (): Array<ColumnProps<GroupedInventoryStockItemForCostInfo>> => {
    return [
      simpleColumn(locales.amount, (g) => `${numberGroupFormatter(g.amount)} ${locales.pcs}`),
      simpleColumn(locales.initial_cost, (g) => renderFixedPriceColumn(g.initialCost)),
      simpleColumn(locales.profit_margin_percent, (g) => `${numberGroupFormatter(g.profitMargin.toFixed(0))}%`),
      simpleColumn(locales.unit_price, (g) => renderFixedPriceColumn(this.groupTotalCost(g))),
    ];
  };

  private getSortedGroupedRows = (entry?: MaintenanceHistoryItemEntry): GroupedInventoryStockItemForCostInfo[] => {
    const groupedItems = entry?.groupedItems || [];
    return [...groupedItems].sort((a, b) => this.groupTotalCost(b) - this.groupTotalCost(a));
  };

  private groupTotalCost = (group: GroupedInventoryStockItemForCostInfo): number => {
    return group.initialCost * (1 + group.profitMargin / 100);
  };

}

export default MaintenanceEntryGroupModal;



// WEBPACK FOOTER //
// ./src/maintenance/MaintenanceEntryGroupModal.tsx